import { ToastContext } from "@shared/context/ToastProvider";
import { useContext } from "react";

const useToast = () => useContext(ToastContext);

export default useToast;
